import { render, staticRenderFns } from "./ListKit.vue?vue&type=template&id=befc720c&scoped=true&"
import script from "./ListKit.vue?vue&type=script&lang=js&"
export * from "./ListKit.vue?vue&type=script&lang=js&"
import style0 from "./ListKit.vue?vue&type=style&index=0&id=befc720c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc720c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
